export default __webpack_public_path__ + "static/media/wg.5034db2c.png";